class ListStatusGuard {
    static isEditable(status) {
        return ['draft', 'ready'].includes(status);
    }

    static canDeleteList(status) {
        return this.isEditable(status);
    }

    static canManageProducts(status) {
        return this.isEditable(status);
    }

    static canMergeList(status) {
        return this.isEditable(status);
    }

    static canFinalize(status, itemsCount = 0) {
        return status === 'draft' && Number(itemsCount) > 0;
    }

    static canSetProgrammed(status) {
        return status === 'ready' || status === 'programmed';
    }

    static canDirectSendList(status) {
        return status === 'ready';
    }

    static canExtendBidding(status) {
        return status === 'bidding_open';
    }

    static canStopBidding(status) {
        return status === 'bidding_open';
    }

    static canFinalValidate(status) {
        return status === 'bidding_closed';
    }

    static canDirectSendSublist(sublist) {
        const sentItemsCount = Number(sublist?.sent_items_count) || 0;
        const totalItemsCount = Number(sublist?.total_items_count) || 0;

        if (totalItemsCount === 0) {
            return false;
        }

        return sentItemsCount < totalItemsCount;
    }

    static getManualSupplierStatus(supplierList) {
        if (!supplierList) {
            return 'open';
        }

        if (typeof supplierList.status === 'string' && supplierList.status.trim() !== '') {
            return supplierList.status;
        }

        if (supplierList.blocked === true || supplierList.is_blocked === true) {
            return 'blocked';
        }

        return 'open';
    }

    static getPendingItemsCount(supplierList) {
        const directCount = supplierList?.pending_items_count;
        if (Number.isFinite(Number(directCount))) {
            return Number(directCount);
        }

        const nestedCount = supplierList?.counts?.pending;
        if (Number.isFinite(Number(nestedCount))) {
            return Number(nestedCount);
        }

        if (Array.isArray(supplierList?.items)) {
            return supplierList.items.filter(item => item?.procurement_status === 'pending').length;
        }

        return 0;
    }

    static canTogglePrepared(listStatus, supplierList) {
        return (
            listStatus === 'manual_processing' &&
            this.getManualSupplierStatus(supplierList) === 'open' &&
            !supplierList?.isUnassigned &&
            supplierList?.supplier?.id !== null &&
            supplierList?.supplier?.id !== undefined
        );
    }

    static canBlockSupplierList(listStatus, supplierList) {
        return (
            listStatus === 'manual_processing' &&
            this.getManualSupplierStatus(supplierList) === 'open' &&
            this.getPendingItemsCount(supplierList) === 0
        );
    }

    static canArchive(listStatus, listRecord) {
        if (listStatus !== 'manual_processing') {
            return false;
        }

        const canArchiveFlag =
            listRecord?.manual_processing_counts?.can_archive ??
            listRecord?.can_archive;
        if (canArchiveFlag !== undefined) {
            return Boolean(canArchiveFlag);
        }

        const allSupplierListsBlocked =
            listRecord?.manual_processing_counts?.all_supplier_lists_blocked ??
            listRecord?.all_supplier_lists_blocked ??
            listRecord?.allSupplierListsBlocked;

        if (allSupplierListsBlocked === undefined) {
            return false;
        }

        return Boolean(allSupplierListsBlocked);
    }

    static canManageManualProcessingItems(listStatus, supplierListStatus) {
        return listStatus === 'manual_processing' && supplierListStatus === 'open';
    }

    static canMoveManualProcessingItemToUnassigned(listStatus, supplierListStatus, isUnassigned) {
        return !isUnassigned && this.canManageManualProcessingItems(listStatus, supplierListStatus);
    }
}

export default ListStatusGuard;
